import { useTitrePage } from '@/lib/titre-page';
import { Button } from '@pms-digital/design-system';

interface TraductionIntrouvableProps {
  onNouveauTexte: () => void;
}

/** `/resultat/$id` with an identifier nobody knows (a state with no mockup). */
export function TraductionIntrouvable({ onNouveauTexte }: TraductionIntrouvableProps) {
  useTitrePage('Traduction introuvable');
  return (
    <div className="flex flex-col items-start gap-6">
      <h1 className="font-light text-h2 leading-[1.2]">Cette traduction est introuvable.</h1>
      <Button type="button" variant="secondary" icon="add" onClick={onNouveauTexte}>
        nouveau texte
      </Button>
    </div>
  );
}
